import React from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import FloatingLogoutButton from './FloatingLogoutButton';
import { TbkConnectionProvider } from '../../context/TbkConnectionContext';

const MainLayout = ({ children, onLogout }) => {
    const location = useLocation();
    return (
        <TbkConnectionProvider>
            <div className="flex flex-col h-screen" style={{ backgroundColor: '#ffffff' }}>
                <motion.main
                    key={location.pathname}
                    className="flex-1 overflow-auto"
                    initial={{ opacity: 0, y: 14 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.22, ease: [0.4, 0, 0.2, 1] }}
                >
                    <div className="h-full">{children}</div>
                </motion.main>
                <FloatingLogoutButton onLogout={onLogout} />
            </div>
        </TbkConnectionProvider>
    );
};

export default MainLayout;